import {css, keyframes} from 'styled-components';

export const fadeIn = ({time = '1s', type = 'ease'} = {}) => css`
  animation: ${time} ${fadeInKeyFrames} ${type};
`;

export const dropIn = ({time = '1s', type = 'ease'} = {}) => css`
  animation: ${time} ${dropKeyFrame} ${type};
`;

export const zoom = ({time = '1s', type = 'ease'} = {}) => css`
  animation: ${time} ${zoomKeyFrame} ${type};
`;
export const loop = ({time = '1s', type = 'ease-in-out infinite backwards'} = {}) => css`
  animation: ${time} ${keyLoop} ${type};
`;

const fadeInKeyFrames = keyframes`
  from {
    filter: blur(5px);
    opacity: 0;
  }

  to {
    filter: blur(0);
    opacity: 1;
  }
`;

const dropKeyFrame = keyframes`
  0% {
    height: 0%;
    overflow-y: hidden;
  }

  100% {
    height: 100%;
    overflow-y: hidden;
  }
`;

const zoomKeyFrame = keyframes`
  0% {
    transform: scale(0.2);
  }

  100% {
    transform: scale(1);
  }
`;

const keyLoop = keyframes`
  100% {
    transform:rotate(360deg);
  }
`;
